import { axiosPatientInstance } from "config";
import { useQuery } from "react-query";

function useEncounterDNRFile(encounterId: string) {
  return useQuery(
    ["DNRFile", { encounterId }],
    () =>
      axiosPatientInstance.get<Blob>(
        `v1/encounter/${encounterId}/form/files/dnr`,
        { responseType: "blob" }
      ),
    { staleTime: 60000 }
  );
}

export { useEncounterDNRFile };
